import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import LogoFooter from './LogoFooter';

interface FooterNavProps {
  className?: string;
}

const GET_STARTED_OPTIONS = [
  {
    title: 'Fee Schedule',
    link: '/ocs_fee_schedule_updated_march_2026.pdf'
  },
  {
    title: 'Official Rules',
    link: '/opencash_weekly_prize_pool_official_rules_oct_2026_ma_exclusion.pdf'
  },
  { title: 'Support', link: '/contact-us', internal: true },
  { title: 'Account FAQs', link: '/account-faq', internal: true },
  { title: 'General FAQs', link: '/general-faq', internal: true }
];

const LEGAL_OPTIONS = [
  {
    title: 'Privacy',
    link: '/oc_privacy_policy_feb_2026.pdf'
  },
  { title: 'Disclosures', link: '/disclosures', internal: true },
  {
    title: 'Form CRS',
    link: '/ocs_customer_relationship_summary.pdf'
  },
  {
    title: 'Business Continuity Plan',
    link: '/opencash_securities_llc_bcp_summary_statement.pdf'
  }
];

const COMPANY_OPTIONS = [
  {
    title: 'About Us',
    link: '/about',
    internal: true
  }
];

const FooterNav: FunctionComponent<FooterNavProps> = ({ className, ...props }) => {
  const classes = classNames('footer-nav col-md-12 footer-hr', className);

  const renderItem = (item: { title: string; link: string; internal?: boolean }, index: any) => {
    return (
      <li key={String(index)} className="nav-item mb-2">
        {item.internal ? (
          <Link className="nav-link p-0 text-muted" to={item.link}>
            {item.title}
          </Link>
        ) : (
          <a
            className="nav-link p-0 text-muted"
            href={item.link}
            target="_blank"
            rel="noopener noreferrer">
            {item.title}
          </a>
        )}
      </li>
    );
  };

  return (
    <div {...props} className={classes}>
      <div className="row">
        <div className="col-md-3 mb-5">
          <LogoFooter />
        </div>
        <div className="col-md-3 mb-3">
          <span>Get Started</span>
          <ul className="list-reset">{GET_STARTED_OPTIONS?.map(renderItem)}</ul>
        </div>
        <div className="col-md-3 mb-3">
          <span>Company</span>
          <ul className="list-reset">{COMPANY_OPTIONS?.map(renderItem)}</ul>
        </div>
        <div className="col-md-3 mb-3">
          <span>Legal</span>
          <ul className="list-reset">{LEGAL_OPTIONS?.map(renderItem)}</ul>
        </div>
      </div>
    </div>
  );
};

export default FooterNav;
